import { ListObjectsV2Output, Object } from "aws-sdk/clients/s3";
import { THUMB_EXT } from "config";
import {
  folderFactory,
  fileFactory,
} from "pages/home/components/contentController/utils";
import { BucketFolder, BucketFile } from "types";
import { Content, SortOrder, SortStatus } from "./types";
import { orderBy } from "lodash";

export const convertToContents = (bucketData: ListObjectsV2Output) => {
  const newFolderList: BucketFolder[] = [];
  const newFileList: BucketFile[] = [];

  bucketData?.CommonPrefixes?.forEach((entry) => {
    const folders = folderFactory(entry);
    newFolderList.push(folders);
  });
  const obsoleteThumbnailsPath: string[] = [];
  const usedThumbnail: Object[] = [];
  const content: Object[] = [];

  bucketData?.Contents?.forEach((item, index, array) => {
    if (item?.Key?.substring(item?.Key?.lastIndexOf(".") + 1) === THUMB_EXT) {
      const index = array.findIndex((o) => o.Key === item.Key?.slice(0, -4)); // i remove ".thb" from the item
      index === -1
        ? obsoleteThumbnailsPath.push(item.Key)
        : usedThumbnail.push(item);
    } else {
      content.push(item);
    }
  });

  content?.forEach((entry) => {
    const files = fileFactory(entry, usedThumbnail);
    newFileList.push(files);
  });

  return {
    folderList: newFolderList,
    fileList: newFileList,
    obsoleteThumbnailsPath,
  };
};

/**
 * Sort utils
 */
const sortFolder = (folders: BucketFolder[], order: SortOrder) =>
  orderBy(folders, ["name"], order);

const sortFile = (files: BucketFile[], { property, order }: SortStatus) => {
  const mappedProperty: keyof BucketFile =
    property === "name"
      ? "fileName"
      : property === "creationDate"
      ? "creationDate"
      : "size";
  const sortedArray = orderBy(files, [mappedProperty], order);
  return sortedArray;
};

export const sortContent = (
  content: Content,
  sortStatus: SortStatus
): Content => {
  const { folderList, fileList } = content;
  const { property, order } = sortStatus;
  const sortedFolders = sortFolder(
    folderList,
    property === "name" ? order : "asc"
  );
  const sortedFiles = sortFile(fileList, sortStatus);
  return { folderList: sortedFolders, fileList: sortedFiles };
};
